import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { GlobalVariable } from '../global';
import { ServerService } from '../providers/server.service';

@Component({
  selector: 'app-my-businesses',
  templateUrl: './my-businesses.page.html',
  styleUrls: ['./my-businesses.page.scss'],
})
export class MyBusinessesPage implements OnInit {
@Input('udid')udid;
@Input('first_name')first_name;
@Input('last_name')last_name;
isDataLoaded:boolean=false;
myBusinesses=[]

  constructor(
    public server:ServerService,
    public globals:GlobalVariable,
     private modalController: ModalController,
     public router:Router,


  ) { }

  ngOnInit() {
  }
ionViewWillEnter(){
  this.getBusinesses();
}
close(){
  this.modalController.dismiss();

}
// async openUserbusiness(user){
//   console.log(user)
//   let modal =await this.modalController.create({
//     component:MyBusinessesPage,
//     componentProps:{ udid: user.udid,
//     first_name:user.first_name,
//   last_name:user.last_name},
   

//   })
//   modal.present();
//   modal.onDidDismiss().then(res=>{
//     console.log(res)
//   })

// }
  getBusinesses(){
    // let id
    this.isDataLoaded=false;
    this.server.showUserBusiness(this.udid).subscribe(res=>{
    this.isDataLoaded=true;
    if(res.status){
     this.myBusinesses= res.data;
    }
    else{
      this.globals.presentToast(res.message? res.message: 'Failed to load data or no data found');
    }

      console.log(res);

    },err=>{
      this.globals.presentToast('Network error')
      console.log(err);

    })

  }
  navigate(business) {
    this.modalController.dismiss();
    let name = business.name + '-' + business.address;
    // console.log(business.name,business.address)
    name = name.replace(/[^a-zA-Z ]/g, '');
    name = name.replace(/ /g, '-');
    name = name.replace(/--/g, '-');
    // value=value.replace(/,/g,'')
    this.router.navigateByUrl('' + name + '/' + business.business_id, {
      state: { businessData: {}, uniqueid: business.business_id },
    });
  }
}
